import { render } from "./IconRfidPowerHigh.vue?vue&type=template&id=229ed5e6"
import script from "./IconRfidPowerHigh.vue?vue&type=script&lang=ts"
export * from "./IconRfidPowerHigh.vue?vue&type=script&lang=ts"
script.render = render

export default script